// src/views/accueil/CarteAccueil.jsx — UNE DES QUATRE CARTES DE L'ACCUEIL.
//
// ⚠️⚠️ AUCUN FILET COLORÉ — ni vertical à gauche, ni horizontal en tête.
// C'est une RÈGLE DU PROJET, pas une préférence de cet écran. Le repère est
// la pastille et le compteur, rien d'autre.
//
// ⚠️ LES LIGNES SONT BLANCHES sur le fond teinté — c'est ce qui les fait
// ressortir. Une ligne teintée dans une carte teintée disparaît.
//
// ⚠️ ET LA CARTE DIT POURQUOI ELLE N'A RIEN. Trois vides ne se ressemblent
// pas : « on lit », « la lecture a échoué », « il n'y a rien ». Les confondre,
// c'est poser un « tout va bien » sur une requête ratée — le défaut que cette
// refonte chasse en premier.

import { DS } from '../../lib/ui'
import { TONS, BORD, GRIS, GRIS_D, NAVY, NAVY_D, CIEL_P } from './_tons'

/** Une ligne blanche de carte — 52px de haut, atteignable au doigt. */
export function LigneCarte({ pastille, pastilleStyle, titre, sousTitre, sousTitreStyle,
  droite, onClic, bordure, fond, testId }) {
  return (
    <button type="button" data-testid={testId} onClick={onClic}
      className="fbz-press fbz-tap"
      style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%',
        textAlign: 'left', background: fond || '#fff',
        border: `1px solid ${bordure || 'rgba(255,255,255,.85)'}`,
        borderRadius: 12, padding: '9px 11px', marginBottom: 7, minHeight: 52,
        fontFamily: DS.fontBody, cursor: onClic ? 'pointer' : 'default' }}>
      <span style={{ width: 30, height: 30, borderRadius: 8, flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 13, fontWeight: 700, background: CIEL_P, color: NAVY,
        ...(pastilleStyle || {}) }}>{pastille}</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 12.5, color: NAVY_D, fontWeight: 600,
          overflow: 'hidden', textOverflow: 'ellipsis' }}>{titre}</span>
        {sousTitre && (
          <span style={{ display: 'block', fontSize: 10.5, color: GRIS, marginTop: 2,
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            ...(sousTitreStyle || {}) }}>{sousTitre}</span>
        )}
      </span>
      {droite}
      {onClic && <span aria-hidden="true" style={{ fontSize: 16, color: GRIS_D, flexShrink: 0 }}>›</span>}
    </button>
  )
}

/**
 * LA PHRASE DU VIDE — celle qui dit POURQUOI.
 * `etat` : 'lecture' | 'echec' | 'vide'. Jamais de quatrième cas muet.
 */
export function PhraseVide({ etat, motif, quandRien, testId }) {
  const phrase = etat === 'lecture' ? 'On lit…'
    : etat === 'echec' ? (motif || 'La lecture a échoué')
      : quandRien
  return (
    <div data-testid={testId}
      style={{ fontFamily: DS.fontBody, fontSize: 11.5, lineHeight: 1.45,
        color: etat === 'echec' ? '#8f2f1d' : GRIS,
        padding: '4px 2px 10px' }}>
      {phrase}
    </div>
  )
}

export default function CarteAccueil({ titre, ton = 'gris', icone, compteur, enfants, testId }) {
  const [fond, bord, plein, surPlein, couleurTitre] = TONS[ton] || TONS.gris
  return (
    <section data-testid={testId}
      style={{ background: fond, border: `1px solid ${bord || BORD}`, borderRadius: 14,
        padding: '11px 12px 6px', fontFamily: DS.fontBody }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 0 11px' }}>
        <span style={{ width: 28, height: 28, borderRadius: 9, flexShrink: 0,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: plein, color: surPlein }}>{icone}</span>
        <h3 style={{ fontSize: 11.5, color: couleurTitre, fontWeight: 600, margin: 0,
          flex: 1, minWidth: 0 }}>{titre}</h3>
        {compteur !== null && compteur !== undefined && (
          <span data-testid={testId ? `${testId}-compteur` : undefined}
            style={{ background: plein, color: '#fff', borderRadius: 20, minWidth: 20,
              height: 20, fontSize: 11, fontWeight: 600, display: 'inline-flex',
              alignItems: 'center', justifyContent: 'center', padding: '0 6px',
              fontVariantNumeric: 'tabular-nums' }}>{compteur}</span>
        )}
      </div>
      {enfants}
    </section>
  )
}
